export class PasswordRegexBuilder {
  constructor(passwordRules) {
    this.passwordRules = passwordRules;
  }

  buildRegex() {
    const { minLength, specialChars, specialNumbers } = this.passwordRules;
    let regex = `^(?=.{${minLength},})`; 

    if (specialChars > 0) {
      regex += `(?=(.*[!@#$%^&*()\\-_=+{};:,<.>]){${specialChars}})`;
    }

    if (specialNumbers > 0) {
      regex += `(?=(.*\\d){${specialNumbers}})`;
    }

    regex += `[A-Za-z\\d!@#$%^&*()\\-_=+{};:,<.>]+$`;
    return regex;
  }
  getRemainingLength() {
    const { minLength, specialChars, specialNumbers } = this.passwordRules;

    if (!minLength) {
      return 0;
    }

    const usedLength = (specialChars || 0) + (specialNumbers || 0);
    return Math.max(minLength - usedLength, 0);  
  }
}
